import { Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DOMPurify from 'dompurify';
import {
  MainContentWrapper,
  ModalWrapper,
  TypographyBoldedWrapper,
  TypographyWithBottomTextWrapper,
  TypographyWithIconWrapper,
  TypographyWrapper
} from './styles';
import GroupHeader from '../../GroupHeader';
import { useTranslation } from 'react-i18next';

type FreezeCardModalInformationProps = {
  isSwanCard: boolean;
};

const FreezeCardModalInformation = ({ isSwanCard }: FreezeCardModalInformationProps) => {
  const { t } = useTranslation(['flexflow']);

  return (
    <ModalWrapper>
      <GroupHeader>{t('freeze card', { ns: 'flexflow' })}</GroupHeader>
      <div>
        <MainContentWrapper>
          <TypographyBoldedWrapper variant="subtitle1">
            {t('this action is temporary and can be undone', {
              ns: 'flexflow'
            })}
          </TypographyBoldedWrapper>
          <TypographyWrapper variant="subtitle1">
            {t('freezing the card temporarily deactivates it and no purchases can be made with it', { ns: 'flexflow' })}
          </TypographyWrapper>
          <TypographyWrapper variant="subtitle1">
            {t(
              'both the administrator from the dashboard and the employee from the Payflow app can freeze and unfreeze the card whenever necessary',
              { ns: 'flexflow' }
            )}
          </TypographyWrapper>

          {isSwanCard && (
            <TypographyWrapper
              variant="subtitle1"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  `${t(
                    'in some cases, the card may be frozen for 24 hours for security reasons and can only be unfrozen after this time',
                    {
                      ns: 'flexflow'
                    }
                  )}`
                )
              }}
            ></TypographyWrapper>
          )}

          <TypographyWithIconWrapper variant="subtitle1">
            <ErrorOutlineIcon
              sx={theme => ({
                '&.MuiSvgIcon-root': {
                  display: 'flex',
                  transform: 'rotate(180deg)',
                  marginRight: '12px',
                  width: '20px',
                  height: '20px',
                  color: theme.palette.primary.main
                }
              })}
            />

            <div>
              {t('if an employee is marked as inactive the card will be frozen automatically', { ns: 'flexflow' })}
            </div>
          </TypographyWithIconWrapper>
        </MainContentWrapper>

        <TypographyWithBottomTextWrapper variant="subtitle2">
          <div>{t('when to freeze a card', { ns: 'flexflow' })}</div>
          <div>
            {t(
              'for example if the card has been lost it can be frozen for security reasons until it is found if the card is not to be used for a few days if the card is stolen to prevent unauthorised transactions until it is permanently blocked',
              { ns: 'flexflow' }
            )}
          </div>
        </TypographyWithBottomTextWrapper>
      </div>
    </ModalWrapper>
  );
};

export default FreezeCardModalInformation;
